import Loader from "../../utils/Loader";

export default function CaptableLoginPage() {
  return <Loader />;
}
